import { Expose, Transform } from "class-transformer";
import { parseAppDate } from "@/utils/dates/dateFormats";
import { toCents } from "@/utils/numberUtils";

export class CreateItemDto {
  @Expose()
  itemModelId: string;

  @Expose()
  serialNumber: string;

  @Expose()
  companyId: string;

  @Expose()
  @Transform(({ value }) => parseAppDate(value, false))
  purchaseDate: string;

  @Expose()
  @Transform(({ value }) => parseAppDate(value, false))
  amortizationStartDate: string;

  @Expose()
  @Transform(({ value }) => toCents(value))
  price: number;

  @Expose()
  warehouseId: string;

  @Expose()
  operativeUnitId: string;

  @Expose()
  locationId: string;

  @Expose()
  @Transform(({ value }) => parseAppDate(value, false))
  nextReviewDate?: Date;

  @Expose()
  certificateNumber?: string;

  @Expose()
  notes?: string;

  @Expose()
  appearsInChecklist: boolean;

  @Expose()
  generatesIssuesInChecklist: boolean;
}
